import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {SelectedFilterValuesModel} from '../../dialogs/grid-filter/selected-filter-values.model';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import { CardComponent } from '../../core/visual/card/card.component';
import { MatTextInputComponent } from '../../editors/mat-text-input/mat-text-input.component';
import { MatPhoneNumberInputComponent } from '../../editors/mat-phone-number-input/mat-phone-number-input.component';

export interface CurrentCurrentFilterData {
  filter: Array<SelectedFilterValuesModel>;
}

@Component({
    selector: 'app-contact-list-filter-dialog',
    templateUrl: './contact-list-filter-dialog.component.html',
    styleUrls: ['./contact-list-filter-dialog.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        MatDialogTitle,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        FormsModule,
        CardComponent,
        MatTextInputComponent,
        MatPhoneNumberInputComponent,
        MatDialogActions,
        MatButton,
    ],
})
export class ContactListFilterDialogComponent implements OnInit, OnDestroy {

  firstName = '';
  lastName = '';
  email = '';
  phoneNumber = '';
  faxNumber = '';
  mobileNumber = '';
  companyName = '';
  position = '';
  speedDial = '';

  constructor(public dialogRef: MatDialogRef<ContactListFilterDialogComponent>,
              public dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: CurrentCurrentFilterData) {
  }

  ngOnInit() {
    if (this.data.filter) {
      for (const filterOption of this.data.filter) {
        if (filterOption.filterKey === 'firstName') {
          this.firstName = filterOption.values[0];
        } else if (filterOption.filterKey === 'lastName') {
          this.lastName = filterOption.values[0];
        } else if (filterOption.filterKey === 'mobileNumber') {
          this.mobileNumber = filterOption.values[0];
        } else if (filterOption.filterKey === 'faxNumber') {
          this.faxNumber = filterOption.values[0];
        } else if (filterOption.filterKey === 'phoneNumber') {
          this.phoneNumber = filterOption.values[0];
        } else if (filterOption.filterKey === 'companyName') {
          this.companyName = filterOption.values[0];
        } else if (filterOption.filterKey === 'email') {
          this.email = filterOption.values[0];
        } else if (filterOption.filterKey === 'position') {
          this.position = filterOption.values[0];
        } else if (filterOption.filterKey === 'speedDial') {
          this.speedDial = filterOption.values[0];
        }
      }
    }
  }

  ngOnDestroy() {
  }

  closeSendConfirmPopup(action: string) {
    if (action === 'close') {
      this.dialogRef.close();
    } else {
      const filter: SelectedFilterValuesModel[] = [];

      const tagsFilter = this.data.filter.find(x => x.filterKey === 'tags');
      if (tagsFilter) {
        filter.push(tagsFilter);
      }

      const directoryFilter = this.data.filter.find(x => x.filterKey === 'directory');
      if (directoryFilter) {
        filter.push(directoryFilter);
      }

      if (this.firstName) {
        filter.push({
          filterKey: 'firstName',
          multiValue: false,
          title: 'First Name',
          values: [this.firstName],
          displayValues: [this.firstName]
        });
      }

      if (this.lastName) {
        filter.push({
          filterKey: 'lastName',
          multiValue: false,
          title: 'Last Name',
          values: [this.lastName],
          displayValues: [this.lastName]
        });
      }

      if (this.phoneNumber) {
        filter.push({
          filterKey: 'phoneNumber',
          multiValue: false,
          title: 'Phone Number',
          values: [this.phoneNumber],
          displayValues: [this.phoneNumber]
        });
      }

      if (this.mobileNumber) {
        filter.push({
          filterKey: 'mobileNumber',
          multiValue: false,
          title: 'Mobile Number',
          values: [this.mobileNumber],
          displayValues: [this.mobileNumber]
        });
      }

      if (this.faxNumber) {
        filter.push({
          filterKey: 'faxNumber',
          multiValue: false,
          title: 'Fax Number',
          values: [this.faxNumber],
          displayValues: [this.faxNumber]
        });
      }

      if (this.companyName) {
        filter.push({
          filterKey: 'companyName',
          multiValue: false,
          title: 'Company Name',
          values: [this.companyName],
          displayValues: [this.companyName]
        });
      }

      if (this.email) {
        filter.push({
          filterKey: 'email',
          multiValue: false,
          title: 'Email',
          values: [this.email],
          displayValues: [this.email]
        });
      }

      if (this.email) {
        filter.push({
          filterKey: 'email',
          multiValue: false,
          title: 'Email',
          values: [this.email],
          displayValues: [this.email]
        });
      }

      if (this.position) {
        filter.push({
          filterKey: 'position',
          multiValue: false,
          title: 'Position',
          values: [this.position],
          displayValues: [this.position]
        });
      }

      if (this.speedDial) {
        filter.push({
          filterKey: 'speedDial',
          multiValue: false,
          title: 'Speed Dial',
          values: [this.speedDial],
          displayValues: [this.speedDial]
        });
      }

      this.dialogRef.close(filter);
    }
  }
}
